
    import {
      withCompInfo,
      createComponentMapperModel,
    } from '@wix/editor-elements-integrations';

    const props = withCompInfo<any, any>()(
      ['compData'],
      ({ compData }) => {
        return {
          ...{"illustration":{},"url":"","textButtonLabel":"Start Creating","description":"Create your own lightboxes and link to them for any place in your site.","label":"Link to Lightbox"},
          ...compData,
          
        };
      },
    );

    export default createComponentMapperModel({
      props,
    });
  